<template>
    <div class="dc-container w-100 d-flex flex-column">
        <div style="background-color: rgb(0,0,0, 0.5)" class="pt-4 pb-4">
            <div  class="text-center m-auto p-0 col-12 col-md-6">
                <div class="mb-1">
                    <img src="/logo/Gpuhub-logo-text-white.svg" alt="iRender" height="50" class="no-select">
                </div>
                <div class="d-none d-md-block">
                    <p class="text-white" style="font-size: 1.2rem;">
                        <strong>
                            iRender provides 2 server clusters targeting different services, to ensure that the power requirement of the server system is always available
                        </strong>
                    </p>
                </div>
                <!--<hr class="d-none d-md-block" style="border-color: #acacac; border-style: dashed;"/>-->
                <h4 class="d-none d-md-block"><strong class="text-white">PLEASE SELECT A DATA CENTER</strong></h4>
            </div>
        </div>
        <div class="d-flex flex-column flex-fill flex-md-row align-items-stretch m-auto col-12 col-md-8 col-lg-7"
             style="overflow-y: auto;">
            <div class="flex-fill col-12 col-md-6 position-relative data-center-item">
                <el-card :body-style="{ padding: '0px', position: 'relative', height : '100%'}"
                         style="border: none; height: 100%; position: relative;">
                    <div class="d-flex flex-column w-100 h-100 position-relative">
                        <div>
                            <img src="https://ak.picdn.net/shutterstock/videos/1006658464/thumb/1.jpg" 
                                    class="w-100">
                        </div>
                        <div style="padding: 14px;" class="pb-0 flex-fill">
                            <div>
                                <h4 class="mb-2 text-primary"><strong><span>CPU Hub Datacenter</span></strong></h4>  
                                <ul class="mt-1 d-flex flex-wrap" 
                                    style="list-style: none; margin-left: -0.3rem; margin-right: -0.3rem;">
                                    <li class="w-50 p-1">
                                        <div class="p-1 pl-2 pr-2 d-flex align-items-center"
                                                style="background-color: #f1f1f1; border-radius: 50px;">
                                            <span class="text-muted text-nowrap">2 x 3090</span>                                       
                                            <div style="width: 6rem;">
                                                <img class="ml-4" src="/os/1.svg" alt="" style="height: 0.75rem;"> 
                                                <span class="ml-1 text-success"><small>normal</small></span>
                                            </div>
                                            <div style="width: 6rem;">
                                                <img class="ml-2" src="/os/2.svg" alt="" style="height: 0.75rem;">
                                                <span class="ml-1 text-danger"><small>normal</small></span>
                                            </div>
                                        </div>
                                    </li>
                                    <li class="w-50 p-1">
                                        <div class="p-1 pl-2 pr-2 d-flex align-items-center"
                                                style="background-color: #f1f1f1; border-radius: 50px;">
                                            <span class="text-muted text-nowrap">2 x 3090</span>                                       
                                            <div style="width: 6rem;">
                                                <img class="ml-4" src="/os/1.svg" alt="" style="height: 0.75rem;"> 
                                                <span class="ml-1 text-success"><small>normal</small></span>
                                            </div>
                                            <div style="width: 6rem;">
                                                <img class="ml-2" src="/os/2.svg" alt="" style="height: 0.75rem;">
                                                <span class="ml-1 text-danger"><small>normal</small></span>
                                            </div>
                                        </div>
                                    </li>
                                    <li class="w-50 p-1">
                                        <div class="p-1 pl-2 pr-2 d-flex align-items-center"
                                                style="background-color: #f1f1f1; border-radius: 50px;">
                                            <span class="text-muted text-nowrap">2 x 3090</span>                                       
                                            <div style="width: 6rem;">
                                                <img class="ml-4" src="/os/1.svg" alt="" style="height: 0.75rem;"> 
                                                <span class="ml-1 text-success"><small>normal</small></span>
                                            </div>
                                            <div style="width: 6rem;">
                                                <img class="ml-2" src="/os/2.svg" alt="" style="height: 0.75rem;">
                                                <span class="ml-1 text-danger"><small>normal</small></span>
                                            </div>
                                        </div>
                                    </li>
                                    <li class="w-50 p-1">
                                        <div class="p-1 pl-2 pr-2 d-flex align-items-center"
                                                style="background-color: #f1f1f1; border-radius: 50px;">
                                            <span class="text-muted text-nowrap">2 x 3090</span>                                       
                                            <div style="width: 6rem;">
                                                <img class="ml-4" src="/os/1.svg" alt="" style="height: 0.75rem;"> 
                                                <span class="ml-1 text-success"><small>normal</small></span>
                                            </div>
                                            <div style="width: 6rem;">
                                                <img class="ml-2" src="/os/2.svg" alt="" style="height: 0.75rem;">
                                                <span class="ml-1 text-danger"><small>normal</small></span>
                                            </div>
                                        </div>
                                    </li>
                                    <li class="w-50 p-1">
                                        <div class="p-1 pl-2 pr-2 d-flex align-items-center"
                                                style="background-color: #f1f1f1; border-radius: 50px;">
                                            <span class="text-muted text-nowrap">2 x 3090</span>                                       
                                            <div style="width: 6rem;">
                                                <img class="ml-4" src="/os/1.svg" alt="" style="height: 0.75rem;"> 
                                                <span class="ml-1 text-success"><small>normal</small></span>
                                            </div>
                                            <div style="width: 6rem;">
                                                <img class="ml-2" src="/os/2.svg" alt="" style="height: 0.75rem;">
                                                <span class="ml-1 text-danger"><small>normal</small></span>
                                            </div>
                                        </div>
                                    </li>
                                    <li class="w-50 p-1">
                                        <div class="p-1 pl-2 pr-2 d-flex align-items-center"
                                                style="background-color: #f1f1f1; border-radius: 50px;">
                                            <span class="text-muted text-nowrap">2 x 3090</span>                                       
                                            <div style="width: 6rem;">
                                                <img class="ml-4" src="/os/1.svg" alt="" style="height: 0.75rem;"> 
                                                <span class="ml-1 text-success"><small>normal</small></span>
                                            </div>
                                            <div style="width: 6rem;">
                                                <img class="ml-2" src="/os/2.svg" alt="" style="height: 0.75rem;">
                                                <span class="ml-1 text-warning"><small>low</small></span>
                                            </div>
                                        </div>
                                    </li>
                                </ul>

                                <p><strong class="text-muted">Your account infomations</strong></p>
                                <div>
                                    <div class="flex-column d-flex align-items-start" style="min-width: 5rem;">
                                        <div class="d-flex flex-row justify-content-center align-items-center" 
                                             style="text-decoration: none; cursor: pointer;">
                                            <!---->
                                            <div title="Balance account" class="d-flex flex-row align-items-center mr-3">
                                                <div class="mr-2 text-muted">Main balance</div>
                                                <div style="color: rgb(66, 165, 245);">
                                                    4959.9970
                                                </div>
                                                <div class="d-flex flex-row align-items-center ml-1">
                                                    <img src="/logo/logo-irender-coin.svg" width="11" height="11">
                                                </div>
                                            </div>
                                            <div title="Bonus point" class="d-flex flex-row align-items-center" style="color: black;">
                                                <div class="mr-2 text-muted">Bonus balance</div>
                                                <div>
                                                    -1.0000
                                                </div>
                                                <div class="d-flex flex-row align-items-center ml-1"><i class="el-icon-coin"></i></div>
                                            </div>
                                        </div>
                                        <div class="d-flex align-items-center" 
                                             style="color: rgb(158, 158, 158); margin-top: 0.5rem;">
                                            <div class="mr-2 text-muted">Image status</div>
                                            <div title="Number of images used" class="d-flex flex-row">
                                                <div>1</div>
                                                <div class="ml-1 mr-1">/</div>
                                                <div>52</div>
                                                <div class="ml-1"><i class="el-icon-monitor"></i></div>
                                            </div>
                                            <div title="Drive Z used" class="d-flex flex-row ml-5">
                                                <div class="mr-2 text-muted">Storage status</div>
                                                <div>83 B</div>
                                                <div class="ml-1 mr-1">/</div>
                                                <div>100.00 GB</div>
                                                <div class="ml-1"><i class="el-icon-box"></i></div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </el-card>
            </div>
            <div class="flex-fill col-12 col-md-6 position-relative data-center-item">
                <el-card :body-style="{ padding: '0px', position: 'relative', height : '100%'}"
                            style="border: none; height: 100%; position: relative;">
                    <div class="d-flex flex-column w-100 h-100 position-relative">
                        <div>
                            <img src="https://cutewallpaper.org/21/data-center-wallpaper/Datacenter-Wallpapers-Top-Free-Datacenter-Backgrounds-.jpg" 
                                    class="w-100">
                        </div>
                        <div style="padding: 14px;" class="pb-0 flex-fill">
                            <div>
                                <h4 class="mb-2 text-primary"><strong><span>GPU AI Hub Datacenter</span></strong></h4>
                                <ul class="mt-1 d-flex flex-wrap" 
                                    style="list-style: none; margin-left: -0.3rem; margin-right: -0.3rem;">
                                    <li class="w-50 p-1">
                                        <div class="p-1 pl-2 pr-2 d-flex align-items-center"
                                                style="background-color: #f1f1f1; border-radius: 50px;">
                                            <span class="text-muted text-nowrap">2 x 3090</span>                                       
                                            <div style="width: 6rem;">
                                                <img class="ml-4" src="/os/1.svg" alt="" style="height: 0.75rem;"> 
                                                <span class="ml-1 text-success"><small>normal</small></span>
                                            </div>
                                            <div style="width: 6rem;">
                                                <img class="ml-2" src="/os/2.svg" alt="" style="height: 0.75rem;">
                                                <span class="ml-1 text-danger"><small>normal</small></span>
                                            </div>
                                        </div>
                                    </li>
                                    <li class="w-50 p-1">
                                        <div class="p-1 pl-2 pr-2 d-flex align-items-center"
                                                style="background-color: #f1f1f1; border-radius: 50px;">
                                            <span class="text-muted text-nowrap">2 x 3090</span>                                       
                                            <div style="width: 6rem;">
                                                <img class="ml-4" src="/os/1.svg" alt="" style="height: 0.75rem;"> 
                                                <span class="ml-1 text-success"><small>normal</small></span>
                                            </div>
                                            <div style="width: 6rem;">
                                                <img class="ml-2" src="/os/2.svg" alt="" style="height: 0.75rem;">
                                                <span class="ml-1 text-danger"><small>normal</small></span>
                                            </div>
                                        </div>
                                    </li>
                                    <li class="w-50 p-1">
                                        <div class="p-1 pl-2 pr-2 d-flex align-items-center"
                                                style="background-color: #f1f1f1; border-radius: 50px;">
                                            <span class="text-muted text-nowrap">2 x 3090</span>                                       
                                            <div style="width: 6rem;">
                                                <img class="ml-4" src="/os/1.svg" alt="" style="height: 0.75rem;"> 
                                                <span class="ml-1 text-success"><small>normal</small></span>
                                            </div>
                                            <div style="width: 6rem;">
                                                <img class="ml-2" src="/os/2.svg" alt="" style="height: 0.75rem;">
                                                <span class="ml-1 text-danger"><small>normal</small></span>
                                            </div>
                                        </div>
                                    </li>
                                    <li class="w-50 p-1">
                                        <div class="p-1 pl-2 pr-2 d-flex align-items-center"
                                                style="background-color: #f1f1f1; border-radius: 50px;">
                                            <span class="text-muted text-nowrap">2 x 3090</span>                                       
                                            <div style="width: 6rem;">
                                                <img class="ml-4" src="/os/1.svg" alt="" style="height: 0.75rem;"> 
                                                <span class="ml-1 text-success"><small>normal</small></span>
                                            </div>
                                            <div style="width: 6rem;">
                                                <img class="ml-2" src="/os/2.svg" alt="" style="height: 0.75rem;">
                                                <span class="ml-1 text-danger"><small>normal</small></span>
                                            </div>
                                        </div>
                                    </li>
                                    <li class="w-50 p-1">
                                        <div class="p-1 pl-2 pr-2 d-flex align-items-center"
                                                style="background-color: #f1f1f1; border-radius: 50px;">
                                            <span class="text-muted text-nowrap">2 x 3090</span>                                       
                                            <div style="width: 6rem;">
                                                <img class="ml-4" src="/os/1.svg" alt="" style="height: 0.75rem;"> 
                                                <span class="ml-1 text-success"><small>normal</small></span>
                                            </div>
                                            <div style="width: 6rem;">
                                                <img class="ml-2" src="/os/2.svg" alt="" style="height: 0.75rem;">
                                                <span class="ml-1 text-danger"><small>normal</small></span>
                                            </div>
                                        </div>
                                    </li>
                                    <li class="w-50 p-1">
                                        <div class="p-1 pl-2 pr-2 d-flex align-items-center"
                                                style="background-color: #f1f1f1; border-radius: 50px;">
                                            <span class="text-muted text-nowrap">2 x 3090</span>                                       
                                            <div style="width: 6rem;">
                                                <img class="ml-4" src="/os/1.svg" alt="" style="height: 0.75rem;"> 
                                                <span class="ml-1 text-success"><small>normal</small></span>
                                            </div>
                                            <div style="width: 6rem;">
                                                <img class="ml-2" src="/os/2.svg" alt="" style="height: 0.75rem;">
                                                <span class="ml-1 text-warning"><small>low</small></span>
                                            </div>
                                        </div>
                                    </li>
                                </ul>

                                
                                <p><strong class="text-muted">Your account infomations</strong></p>
                                <div>
                                    <div class="flex-column d-flex align-items-start" style="min-width: 5rem;">
                                        <div class="d-flex flex-row justify-content-center align-items-center" 
                                             style="text-decoration: none; cursor: pointer;">
                                            <!---->
                                            <div title="Balance account" class="d-flex flex-row align-items-center mr-3">
                                                <div class="mr-2 text-muted">Main balance</div>
                                                <div style="color: rgb(66, 165, 245);">
                                                    4959.9970
                                                </div>
                                                <div class="d-flex flex-row align-items-center ml-1">
                                                    <img src="/logo/logo-irender-coin.svg" width="11" height="11">
                                                </div>
                                            </div>
                                            <div title="Bonus point" class="d-flex flex-row align-items-center" style="color: black;">
                                                <div class="mr-2 text-muted">Bonus balance</div>
                                                <div>
                                                    -1.0000
                                                </div>
                                                <div class="d-flex flex-row align-items-center ml-1"><i class="el-icon-coin"></i></div>
                                            </div>
                                        </div>
                                        <div class="d-flex align-items-center" 
                                             style="color: rgb(158, 158, 158); margin-top: 0.5rem;">
                                            <div class="mr-2 text-muted">Image status</div>
                                            <div title="Number of images used" class="d-flex flex-row">
                                                <div>1</div>
                                                <div class="ml-1 mr-1">/</div>
                                                <div>52</div>
                                                <div class="ml-1"><i class="el-icon-monitor"></i></div>
                                            </div>
                                            <div title="Drive Z used" class="d-flex flex-row ml-5">
                                                <div class="mr-2 text-muted">Storage status</div>
                                                <div>83 B</div>
                                                <div class="ml-1 mr-1">/</div>
                                                <div>100.00 GB</div>
                                                <div class="ml-1"><i class="el-icon-box"></i></div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </el-card>
            </div>
        </div>
        <div class="footer p-2 text-white d-block d-md-flex">
            <div class="flex-fill text-center text-md-left">Made with ❤️ and ☕ in Vietnam</div>
            <div class="flex-fill text-center text-md-right">iRender Vietnam JSC © 2021. All rights reserved</div>
        </div>
    </div>
</template>

<script>
    import '@/assets/css/data-center.css';
    export default { 

    }
</script>